import type { FallbackProps } from 'react-error-boundary'
import { AppErrorScreen } from './AppErrorScreen'

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <AppErrorScreen
      error={error}
      fit="page"
      onRetry={resetErrorBoundary}
      onReload={() => globalThis.location.reload()}
    />
  )
}
